import { CSSObject } from "@emotion/react";

import { ICON_DEFAULT_STYLE } from "@/shared";

import { colors } from "@dotnet/telematics-design-system";

export const useStyles = () =>
  ({
    errorIcon: {
      ...ICON_DEFAULT_STYLE,
      color: colors.red700,
      flexShrink: 0,
      margin: "2px 4px 0 0",
      alignSelf: "flex-start"
    }
  }) as CSSObject;
